import '@vaadin/multi-select-combo-box';
import { componentName, MultiSelectComboBoxClass } from './MultiSelectComboBoxClass';

customElements.define(componentName, MultiSelectComboBoxClass);

export { MultiSelectComboBoxClass, componentName };
